// extracted by mini-css-extract-plugin
module.exports = {"CommonBanner":"Banner_CommonBanner__XkMKm"};